// extracted by mini-css-extract-plugin
export default {"forEcrs":"AppVersions_forEcrs__o3JgY"};